import React, { useContext } from 'react'
import { LocalesContext } from '../contexts/LocalesContext'
import { formatValueWithUnit } from '../utils/unitsConverter'

export default function SessionStatsComponent(props) {
  const { t } = useContext(LocalesContext)
  const isImperial = props.unitsSystem === 'imperial'
  const params = props?.session?.params || {}

const { statAverageSpeed, statSuperficieLavorata, statVariations, statSingulation, statDoubles, statSkips, statTotalTarget } = params  
  return (
    <table className="c-table">
      <tbody>
        <tr>
          <th>{t('VelocitaMedia')}</th>
          <td>{statAverageSpeed ? formatValueWithUnit(statAverageSpeed, 'speed', isImperial) : ' - '}</td>
        </tr>
        <tr>
          <th>{t('SuperficieLavorata')}</th>
          <td>{statSuperficieLavorata ? formatValueWithUnit(statSuperficieLavorata, 'area', isImperial) : ' - '}</td>
        </tr>
        <tr>
          <th>{t('DistanzaSemina')}</th>
          <td>{statVariations ? formatValueWithUnit(statVariations, 'length', isImperial) : ' - '}</td>
        </tr>
        <tr>
          <th>{t('Qualita')}</th>
          <td>{statSingulation ? `${statSingulation} %` : ' - '}</td>
        </tr>
        <tr>
          <th>{t('SemiDoppi')}</th>
          <td>{statDoubles ? `${statDoubles} %` : ' - '}</td>
        </tr>
        <tr>
          <th>{t('SemiMancanti')}</th>
          <td>{statSkips ? `${statSkips} %` : ' - '}</td>
        </tr>
        <tr>
          <th>{t('Obiettivo')}</th>
          <td>{statTotalTarget ? formatValueWithUnit(statTotalTarget, 'investment', isImperial) : ' - '}</td>
        </tr>
      </tbody>
    </table>
  )
}